import xss from "xss";

export const sanitize = value => {
  return xss(value, {
    css: false,
    stripIgnoreTag: true,
    whiteList: {
      a: ["href"],
      img: ["src"]
    }
  });
};

export const customChatTemplateSanitizer = (htmlValue, tokens) => {
  const allowedSchemes = ["https", "mailto", "tel"];
  return xss(htmlValue, {
    whiteList: {
      a: ["style", "href"],
      b: ["style"],
      blockquote: ["style"],
      body: ["style"],
      br: ["style"],
      code: ["style"],
      div: ["style"],
      em: ["style"],
      center: ["style"],
      title: ["style"],
      h1: ["style"],
      h2: ["style"],
      h3: ["style"],
      h4: ["style"],
      h5: ["style"],
      h6: ["style"],
      head: ["style"],
      html: ["style"],
      i: ["style"],
      img: ["style", "src"],
      li: ["style"],
      ol: ["style"],
      p: ["style"],
      pre: ["style"],
      small: ["style"],
      span: ["style"],
      strong: ["style"],
      sub: ["style"],
      sup: ["style"],
      table: ["style"],
      tbody: ["style"],
      td: ["style"],
      tfoot: ["style"],
      th: ["style"],
      thead: ["style"],
      tr: ["style"],
      u: ["style"],
      ul: ["style"]
    },
    disallowedTagsMode: "discard",
    allowedSchemes,
    allowProtocolRelative: false,
    enforceHtmlBoundary: false,
    onTagAttr(tag, name, value) {
      if (tag === "a" && name === "href") {
        const cleanedValue = structuredClone(value).replace(
          /(mailto:|tel:)/g,
          ""
        );
        if (tokens.includes(cleanedValue)) return `${name}="${value}"`;
      }
      // on no response, the sanitizer behaves normally
    }
  });
};
